import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { hasNamedSlot } from 'elements/_shared/hasSlot.js'
import { style } from './header-button.style.js'
import { badgeVariantTypes } from 'elements/badge/badge.js'
import { classMap } from 'lit/directives/class-map.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'


initializeIconsByRole({
  'cse-header-button.icon': { name: 'circle', style: 'light' },
})

@customElement('cse-header-button')
export class CSEHeaderButton extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, style]

  @property({ type: Boolean })
  inline = false

  @property({ type: Boolean })
  disabled = false

  @property({ type: String, attribute: 'badge-variant' })
  badgeVariant: badgeVariantTypes[number] = 'default'

  @property({ type: String })
  url = ''

  private renderBadge = () => html`
    <cse-badge variant="${this.badgeVariant}" size="small" composition="floating">
      <slot name="badge"></slot>
    </cse-badge>
  `

  private renderButtonContent = (hasBadge: boolean) => html`
    <div class="icon-wrapper">
      <slot name="icon">
        <cse-icon
          icon-role="cse-header-button.icon"
          class="icon"
          size="lg"
        ></cse-icon>
      </slot>
      ${hasBadge ? this.renderBadge() : nothing}
    </div>
    <slot name="caption" class="font-caption-s"></slot>
  `

  override render() {
    const hasBadge = hasNamedSlot(this, 'badge')
    const isLink = this.url !== ''
    const tabindex = this.disabled ? -1 : 0
    const classes = classMap({
      'cse-header-button': true,
      'inline': this.inline,
      'disabled': this.disabled,
    })

    if (isLink) {
      return html`
        <a href="${this.url}" class="${classes}" tabindex="${tabindex}">
          ${this.renderButtonContent(hasBadge)}
        </a>
      `
    } else {
      return html`
        <button class="${classes}" tabindex="${tabindex}">
          ${this.renderButtonContent(hasBadge)}
        </button>
      `
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-header-button': CSEHeaderButton
  }
}
